module.exports = __webpack_public_path__ + "default.jpg?617e245686506b1302a85e4e62bab5b6";


//////////////////
// WEBPACK FOOTER
// ./src/static/headers/default.jpg
// module id = 880
// module chunks = 0